import { apiClient } from 'model/axiosConfig'


// Type
export type typeStatisticsRequestFilters = {
    storeIds: string[],
    dateFrom: string,
    dateTo: string,
}


// Get Statistic sales
export const getStatisticPayments = async (payload: typeStatisticsRequestFilters) => {

    const path = '/product/statistics/payments'

    const config = {
        headers: {},
    }

    const data: typeStatisticsRequestFilters = {
        storeIds: payload.storeIds,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
    }

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Get Statistic sales
export const getStatisticRefunds = async (payload: typeStatisticsRequestFilters) => {

    const path = '/product/statistics/refunds'

    const config = {
        headers: {},
    }

    const data: typeStatisticsRequestFilters = {
        storeIds: payload.storeIds,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
    }

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}
